import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'mission', data),
  get: (missionId) => Ajax('get', `mission/${missionId}`),
  create: (data) => Ajax('post', 'mission', data),
  update: (missionId, data) => Ajax('put', `mission/${missionId}`, data),
  enable: (missionId) => Ajax('put', `mission/${missionId}/enable`),
  disable: (missionId) => Ajax('put', `mission/${missionId}/disable`),
};
